import React from 'react';
import PropTypes from 'prop-types';


const AdsTitle = props =>
  (
    <div className="signup-title">
      <h1>{props.title}</h1>
      <p>Review your plan and create and account.</p>
    </div>
  );

AdsTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default AdsTitle;



// WEBPACK FOOTER //
// ./src/components/AdsTitle.jsx